import { useState, useEffect } from "react";
import PortfolioCategories from "../../components/PortfolioCategories.jsx";
import ProjectDetailsV3 from "../../components/ProjectDetailsV3.jsx";
import projectsData from "../../projects.json";
import ProjectThumbnailsV5Grid from "../../components/ProjectThumbnailsV5Grid.jsx";
import "./PortfolioV5.css";

const PortfolioV5 = () => {
  const [selectedCategory, setSelectedCategory] = useState("UX Design");
  const [selectedProject, setSelectedProject] = useState(null);
  const [projects, setProjects] = useState([]);
  const displayLimit = 11;

  useEffect(() => {
    setProjects(projectsData);
  }, []);

  const filteredProjects =
    selectedCategory === "All"
      ? projects
      : projects.filter((project) => project.category === selectedCategory);

  const handleProjectClick = (project) => {
    if (selectedProject && selectedProject.id === project.id) {
      setSelectedProject(null);
    } else {
      setSelectedProject(project);
    }
  };

  return (
    <div className="mt-32 portfolio-container">
      <PortfolioCategories
        selectedCategory={selectedCategory}
        onSelectCategory={setSelectedCategory}
      />
      <div style={{ height: "50px" }}></div>
      <div className="portfolio-grid">
        <ProjectThumbnailsV5Grid
          projects={filteredProjects.slice(0, displayLimit)}
          onProjectClick={handleProjectClick}
        />
      </div>
      <div style={{ height: "20px" }}></div>
      {selectedProject && (
        <ProjectDetailsV3
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </div>
  );
};

export default PortfolioV5;
